export const apiUrl = 'https://upload.nationallaserinstitute.com'
//export const apiUrl = 'http://localhost:5000'
export const URL = ''
//export const resetPasswordLink = 'http://localhost:3000'
export const resetPasswordLink = 'https://link.nationallaserinstitute.com'

export const LOCAL_STORAGE_TOKEN_NAME = 'netflixclone2'

export const RESOURCES_SEARCH_SUCCESS = 'RESOURCES_SEARCH_SUCCESS'
export const MOVIES_LOADED_SUCCESS = 'POSTS_LOADED_SUCCESS'
export const MOVIES_LOADED_FAIL = 'POSTS_LOADED_FAIL'
export const ADD_MOVIE = 'ADD_MOVIE'
export const ADD_MOVIE_FAIL = 'ADD_MOVIE_FAIL'
export const DELETE_MOVIE = 'DELETE_MOVIE'

export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS'
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL'
export const USERS_LOADED_SUCCESS = 'USERS_LOADED_SUCCESS'
export const USERS_LOADED_FAIL = 'USERS_LOADED_FAIL'

export const POSTS_LOADED_SUCCESS = 'POSTS_LOADED_SUCCESS'

export const POSTS_LOADED_FAIL = 'POSTS_LOADED_FAIL'
export const GET_POSTS = 'GET_POSTS'

export const POST_LOADED_SUCCESS = 'POST_LOADED_SUCCESS'

export const POST_LOADED_FAIL = 'POST_LOADED_FAIL'
export const GET_POST = 'GET_POST'

export const ADD_USER = 'ADD_USER'
export const ADD_USER_FAIL = 'ADD_USER_FAIL'
export const DELETE_USER = 'DELETE_USER'
export const GET_USERS = 'GET_USERS'
export const GET_USER = 'GET_USER'

export const UPDATE_MOVIE = 'UPDATE_MOVIE'

export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL'
export const FIND_MOVIE = 'FIND_MOVIE'
export const GET_MOVIES = 'GET_MOVIES'
export const GET_LISTS = 'GET_MOVIES'

export const ADD_LIST = 'ADD_LIST'
export const DELETE_LIST = 'DELETE_LIST'
export const DELETE_POST = 'DELETE_POST'

export const LISTS_LOADED_SUCCESS = 'LISTS_LOADED_SUCCESS'
export const ADD_LIST_FAIL = 'ADD_LIST_FAIL'
export const LISTS_LOADED_FAIL = 'LISTS_LOADED_FAIL'

export const FIND_LIST = 'FIND_LIST'
export const UPDATED_SUCCESS = 'UPDATED_SUCCESS'

export const GET_RESOURCES = 'GET_RESOURCES'
export const RESOURCES_LOADED_FAIL = 'RESOURCES_LOADED_FAIL'
export const RESOURCES_LOADED_SUCCESS = 'RESOURCES_LOADED_SUCCESS'
export const GET_RESOURCE = 'GET_RESOURCE'
export const GET_RESOURCES_FAILURE = 'GET_RESOURCES_FAILURE'
export const RESOURCE_LOADED_FAIL = 'RESOURCE_LOADED_FAIL'
export const RESOURCE_LOADED_SUCCESS = 'RESOURCE_LOADED_SUCCESS'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'
export const GET_RESOURCES_SUCCESS = 'GET_RESOURCES_SUCCESS'
export const GET_RESOURCES_START = 'GET_RESOURCES_START'

export const UPLOAD_DATA = 'UPLOAD_DATA'
export const UPLOAD_DATA_FAIL = 'UPLOAD_DATA_FAIL'
export const UPLOAD_DATA_SUCCESS = 'UPLOAD_DATA_SUCCESS'
